import { AuthService } from './../../../../shared/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html'
})
export class ChangePasswordFormComponent implements OnInit {
  title: string = 'Change Password';
  loading: boolean;
  changePassword: any;
  changePasswordForm: FormGroup;
  id;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: AuthService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createChangePasswordForm();
    this.getProfile();
  }

  private getProfile() {
    if (this.id)
      this.service.get(this.id).subscribe((response: any) => {
        if (response) {
          this.changePassword = response;
          this.title = 'Change Password for ' + response.email;
          this.setValueChangePasswordForm();
        }
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
  }

  createChangePasswordForm() {
    this.changePasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {validator: this.passwordMatchValidator});
  }

  setValueChangePasswordForm() {
    this.changePasswordForm.patchValue({
      email: this.changePassword.email
    });
  }

  save() {
    if (this.changePasswordForm.valid) {
      this.loading = true;
      this.changePassword = Object.assign({}, this.changePasswordForm.value);
      if (this.id) {
        this.service.modifyPassword(this.changePassword).subscribe((response) => {
          if (response) {
            this.toastrService.success('Password updated successful');
            this.router.navigate(['/admin/users']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password').value === g.get('confirmPassword').value ? null : {'mismatch': true};
  }
}
